const students = {
  getMyStudents: async function() {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        GetMyStudents(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `)
            {
              Student_Id
              Name
              Grade{
                Grade_Id
                Title
              }
              Organizations(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
                Organization_Id
                Parent_Organization_Id
                Organization_Type_Id
                Account_Id
                Name
              }
              Subjects(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
                Subject_Id
                Title
                Organization{
                  Organization_Id
                  Name
                }
              }
              Student_Units(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
            Student_Unit_Id
              Unit{
                Score_Template_Id
                Unit_Id
                Subject_Id
                Title
              }
              }
            }
          }`
      })
      .then(res => res.data.GetMyStudents);
  },
  getStudentArchivedData: async function(studentId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        GetStudent(studentId: ` +
          parseInt(studentId) +
          `, userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `)
          {
            Student_Id
            All_Subjects(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
                Subject_Id
                Title
              }
              Archived_Student_Units(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
              Student_Unit_Id
              Unit{
                Score_Template_Id
                Unit_Id
                Subject_Id
                Title
              }
            }
          }
        }`
      })
      .then(res => res.data.GetStudent);
  },
  getMyStarredStudents: async function() {
    return await this.$store.getters
      .fetcher({
        query:
          `{
          GetMyStarStudents(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `)
            {
              Student_Id
              Name
              Grade{
                Grade_Id
                Title
              }
              Organizations(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
                Organization_Id
                Parent_Organization_Id
                Organization_Type_Id
                Account_Id
                Name
              }
              Subjects(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
                Subject_Id
                Title
                Organization{
                  Organization_Id
                  Name
                }
              }
              Student_Units(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
            Student_Unit_Id
              Unit{
                Score_Template_Id
                Unit_Id
                Subject_Id
                Title
              }
              }
            }
          }`
      })
      .then(res => res.data.GetMyStarStudents);
  },

  getPermissionStudents: async function() {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        GetPermissionStudents(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `)
            {
              Student_Id
              Name
              Grade{
                Grade_Id
                Title
              }
              PermissionOrganizations{
                Organization_Id
                Parent_Organization_Id
              }
            }
          }`
      })
      .then(res => res.data.GetPermissionStudents);
  },

  getStudent: async function(studentId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        GetStudent(studentId: ` +
          parseInt(studentId) +
          ` userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `)
          {
            Student_Id
            Name
            Grade{
              Grade_Id
              Title
            }
            Organizations(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
              Organization_Id
              Parent_Organization_Id
              Organization_Type_Id
              Account_Id
              Name
            }
            Subjects(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
              Subject_Id
              Title
              Organization{
                Organization_Id
                Name
              }
            }
            Student_Units(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
          Student_Unit_Id
            Unit{
              Score_Template_Id
              Unit_Id
              Subject_Id
              Title
            }
            }
          }
        }`
      })
      .then(res => res.data.GetStudent);
  },

  getDashboardStudents: async function() {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        GetMyStudents(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `)
            {
              Student_Id
              Name
              Grade{
                Grade_Id
                Title
              }
              Subjects(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
                Subject_Id
                Title
                Organization{
                  Organization_Id
                  Name
                }
              }
              Units(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
                Unit_Id
                Subject_Id
                Title
              }
            }
          }`
      })
      .then(res => res.data.GetMyStudents);
  },

  async getMySubjectStudents() {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        GetMyStudents(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `)
            {
              Student_Id
              Name
              Grade{
                Grade_Id
                Title
              }
              Organizations(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
                Organization_Id
              }
              Subjects(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
                Subject_Id
              }
              Units(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
                Unit_Id
                Subject_Id
              }
            }
          }`
      })
      .then(res => res.data.GetMyStudents);
  },

  async getMyArchivedSubjectStudents() {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        GetMyStudents(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `)
            {
              Student_Id
              Name
              Grade{
                Grade_Id
                Title
              }
              Archived_Student_Units(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
              Student_Unit_Id
              Student_Id
              Unit{
                Unit_Id
                Subject_Id
              }
            }
          }
        }`
      })
      .then(res => res.data.GetMyStudents);
  },

  getDashboardStudent: async function(studentId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        GetStudent(studentId: ` +
          parseInt(studentId) +
          ` userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `)
            {
              Student_Id
              Name
              Grade{
                Grade_Id
                Title
              }
              Subjects(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
                Subject_Id
                Title
                Organization{
                  Organization_Id
                  Name
                }
              }
              Units(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `){
                Unit_Id
                Subject_Id
                Title
              }
            }
          }`
      })
      .then(res => res.data.GetStudent);
  },

  getAllGrades: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{
            GetAllGrades{
              Grade_Id
              Title
              Order
            }
          }`
      })
      .then(res => res.data.GetAllGrades);
  },

  createStudent: async function(studentToCreate) {
    const query = `
      mutation($name: String!, $image: String, $gradeId: Int!) {
        CreateStudent(name: $name, image: $image, gradeId: $gradeId){
          Student_Id
        }
      }`;
    const variables = {
      name: studentToCreate.Name,
      image: studentToCreate.Image,
      gradeId: parseInt(studentToCreate.Grade.Grade_Id)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      studentToCreate.Student_Id = res.data.CreateStudent.Student_Id;
      return studentToCreate;
    });
  },

  updateStudent: async function(studentToUpdate) {
    const query = `
      mutation($studentId: Int!, $name: String!, $image: String, $gradeId: Int!) {
        UpdateStudent(studentId: $studentId, name: $name, image: $image, gradeId: $gradeId){
          Student_Id
        }
      }`;
    const variables = {
      studentId: parseInt(studentToUpdate.Student_Id),
      name: studentToUpdate.Name,
      image: studentToUpdate.Image,
      gradeId: parseInt(studentToUpdate.Grade.Grade_Id)
    };
    return this.$store.getters.fetcher({ query, variables }).then(() => {
      return studentToUpdate;
    });
  },

  createManageStudentPermissions: async function(studentId, userIds) {
    const query = `
      mutation($studentId: Int!, $userIds: [Int]!, $permissionId: Int!) {
        CreateUserStudentPermission(studentId: $studentId, userIds: $userIds, permissionId: $permissionId)
      }`;
    const variables = {
      studentId: parseInt(studentId),
      userIds: userIds,
      permissionId: 15
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data);
  },

  createViewStudentPermissions: async function(studentId, userIds) {
    const query = `
      mutation($studentId: Int!, $userIds: [Int]!, $permissionId: Int!) {
        CreateUserStudentPermission(studentId: $studentId, userIds: $userIds, permissionId: $permissionId)
      }`;
    const variables = {
      studentId: parseInt(studentId),
      userIds: userIds,
      permissionId: 14
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data);
  },

  createStudentSubjectPermissions: async function(studentSubjectId, userIds) {
    const query = `
      mutation($studentSubjectId: Int!, $userIds: [Int]!, $permissionId: Int!) {
        CreateUserStudentSubjectPermission(studentSubjectId: $studentSubjectId, userIds: $userIds, permissionId: $permissionId)
      }`;
    const variables = {
      studentSubjectId: parseInt(studentSubjectId),
      userIds: userIds,
      permissionId: 18
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(res => res.data);
  },

  createStarStudent: async function(studentId) {
    const query = `
      mutation($userId: Int!, $studentId: Int!) {
        CreateUserStarStudent(userId: $userId, studentId: $studentId){
          Student_Id
        }
      }`;
    const variables = {
      userId: parseInt(this.$store.getters.user.User_Id),
      studentId: parseInt(studentId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      this.$store.getters.user.Starred_Students.push(
        res.data.CreateUserStarStudent
      );
    });
  },

  removeStarStudent: async function(studentId) {
    const query = `
      mutation($userId: Int!, $studentId: Int!) {
        RemoveUserStarStudent(userId: $userId, studentId: $studentId)
      }`;
    const variables = {
      userId: parseInt(this.$store.getters.user.User_Id),
      studentId: parseInt(studentId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(() => {
      this.$store.getters.user.Starred_Students = this.$store.getters.user.Starred_Students.filter(
        s => s.Student_Id != studentId
      );
    });
  }
};

export { students };
